import React from "react";
import { Outlet } from "react-router";
import { usePrefetch } from "src/ui/utils/usePrefetch";

import { LoadingBox } from "@shared/Loading";
import { TechnicalDifficultiesFallback } from "@shared/TechnicalDifficultiesFallback";

export const PrefetchGuard = () => {
    const { progress, hasPrefetchError, isResolvingWorkspace } = usePrefetch();

    if (hasPrefetchError) {
        return <TechnicalDifficultiesFallback />;
    }

    if (isResolvingWorkspace) {
        return null;
    }

    if (progress !== 100) {
        return <LoadingBox value={progress} size="page" />;
    }

    return <Outlet />;
};
